<div class="pd-aff">
  <div class="d-flex flex-wrap justify-content-between align-items-start mb-3 gap-2">
    <div>
      <h6 class="mb-0">Affichage par champ</h6>
      <p class="mb-0 text-muted small">Définissez où chaque champ apparaît dans l’interface.</p>
    </div>
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">Enregistrer</button>
  </div>

  <div class="row">
    <div class="col-lg-7">
      <div class="card pd-aff__card mb-3" *ngFor="let c of champs; trackBy: trackById">
        <div class="card-body py-2">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>{{ c.libelle }}</strong>
            <code class="small text-muted">{{ c.code }}</code>
          </div>
          <div class="row small">
            <div class="col-6 col-md-4 mb-1" *ngFor="let opt of [
              { k: 'afficherFiche', l: 'Fiche' },
              { k: 'afficherListe', l: 'Liste' },
              { k: 'afficherFiltre', l: 'Filtre' },
              { k: 'afficherRechercheAvancee', l: 'Recherche avancée' },
              { k: 'afficherImpression', l: 'Impression' },
              { k: 'afficherPos', l: 'POS' },
              { k: 'afficherMobile', l: 'Mobile' }
            ]">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="c.id + '-' + opt.k"
                  [(ngModel)]="$any(c.affichage)[opt.k]"
                  [name]="c.id + opt.k"
                />
                <label class="custom-control-label" [for]="c.id + '-' + opt.k">{{ opt.l }}</label>
              </div>
            </div>
          </div>
          <div class="form-row mt-2">
            <div class="form-group col-md-4 mb-1">
              <label class="small mb-0">Onglet cible</label>
              <input class="form-control form-control-sm" [(ngModel)]="c.affichage.ongletCible" />
            </div>
            <div class="form-group col-md-4 mb-1">
              <label class="small mb-0">Section cible</label>
              <input class="form-control form-control-sm" [(ngModel)]="c.affichage.sectionCible" />
            </div>
            <div class="form-group col-md-2 mb-1">
              <label class="small mb-0">Ordre</label>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="c.affichage.ordreAffichage" />
            </div>
            <div class="form-group col-md-2 mb-1">
              <label class="small mb-0">Largeur col.</label>
              <input class="form-control form-control-sm" [(ngModel)]="c.affichage.largeurColonne" placeholder="auto" />
            </div>
          </div>
        </div>
      </div>
      <p *ngIf="champs.length === 0" class="text-muted small">Aucun champ — créez-en dans l’onglet Champs.</p>
    </div>

    <div class="col-lg-5">
      <div class="card pd-aff__preview">
        <div class="card-header py-2"><strong>Prévisualisation (maquette)</strong></div>
        <div class="card-body">
          <div class="pd-mock-fiche">
            <div class="pd-mock-fiche__title">Fiche {{ moduleKey }}</div>
            <div class="pd-mock-fiche__row" *ngFor="let c of champs">
              <ng-container *ngIf="c.affichage.afficherFiche">
                <span class="pd-mock-fiche__label">{{ c.libelle }}</span>
                <span class="pd-mock-fiche__value text-muted">…</span>
              </ng-container>
            </div>
            <p *ngIf="!champs.length" class="text-muted small mb-0">Aucun champ à prévisualiser.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
